// This file provides webpack polyfills for Node.js modules
// Create React App with webpack 5 no longer includes these polyfills by default

// Import necessary modules
import { Buffer } from 'buffer';
// Use the browser version of process
import process from 'process/browser';

// Make Buffer and process available globally
window.Buffer = Buffer;
window.process = process;

// This file needs to be imported in your entry point (index.jsx)